<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/books">
      <icon name="books" class="mr-2 w-8 h-8"
        :class="isUrl('books') ? 'fill-accent-primary-text' : 'fill-accent-primary-text group-hover:fill-accent-primary-text'" />
      <div :class="isUrl('books') ? 'text-accent-primary-text font-medium' : 'text-accent-primary-text group-hover:text-accent-primary-text'">Boeken</div>
      </Link>
    </div>

    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/users">
      <icon name="users" class="mr-2 w-8 h-8"
        :class="isUrl('users') ? 'fill-accent-primary-text' : 'fill-accent-primary-text group-hover:fill-accent-primary-text'" />
      <div :class="isUrl('users') ? 'text-accent-primary-text font-medium' : 'text-accent-primary-text group-hover:text-accent-primary-text'">Gebruikers</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/municipalities">
      <icon name="municipalities" class="mr-2 w-8 h-8"
        :class="isUrl('municipalities') ? 'fill-accent-primary-text' : 'fill-accent-primary-text group-hover:fill-accent-primary-text'" />
      <div :class="isUrl('municipalities') ? 'text-accent-primary-text font-medium' : 'text-accent-primary-text group-hover:text-accent-primary-text'">Wijken
      </div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
